import { Routes, Route } from 'react-router-dom';
import type { RouteConfig } from '../../types/routes/RouteConfig';
import { Render } from './Render';

export const renderRoutes = (routes: Array<RouteConfig>) => {
    return (
        <Routes>
            {routes.map((route) => {
                const { path, defaultComponent, defaultLayout, defaultLayoutProps } = route;
                const key = btoa(path);

                return <Route path={path} key={key} element={<Render path={path} defaultLayout={defaultLayout} defaultLayoutProps={defaultLayoutProps} defaultComponent={defaultComponent} />} />;
            })}
        </Routes>
    );
};
